/**
 * 按元素类型高亮元素的组件，只有机器审核在用
 */
import React, { useState, useEffect, CSSProperties } from 'react';
import SelectedElementWrapperUtil from '@src/framework/editor/src/page/index/components/canvas/edit-panel/selected-element-layer/utils';
import { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { IBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/base-model.interface';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import { isEditorEmpty } from '@src/slide/domain/ui-model/element-modeles/property/text/utils/utils';
import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';

const DEFAULT_TEXT_COLOR = '#FF0000';
const DEFAULT_IMG_COLOR = '#0000FF';
const DEFAULT_CHART_COLOR = '#00FF00';

interface MachineAuditBorderOption {
    style: CSSProperties;
}

interface IMachineAuditBorderProps {
    slide: ISlideModel;
    options?: {
        text?: MachineAuditBorderOption;
        picture?: MachineAuditBorderOption;
        chart?: MachineAuditBorderOption;
    };
}

export function MachineAuditBorder({ slide, options }: IMachineAuditBorderProps) {
    // FIXME: 不应该用 elements 作为 state，elements 和重绘没有直接关系，影响不大先不改了
    const [textElements, setTextElements] = useState<IElementBaseModel[]>([]);
    const [imageElements, setImageElements] = useState<IElementBaseModel[]>([]);
    const [chartElements, setChartElements] = useState<IElementBaseModel[]>([]);

    // FIXME: 应当作为一个 props 进行刷新，不然会一直重新注册，影响不大先不改了
    useEffect(() => {
        const eventManager = SlideDataServices.SDKDataServices.EventManager();
        const unbind = eventManager?.on('commit-transaction', () => updateElements());
        return () => unbind?.();
    }, [slide, options]);

    useEffect(() => {
        updateElements();
    }, [slide, options]);

    const updateElements = () => {
        const elements = getBorderElements(slide);
        const layoutElements = slide.layoutRef ? getBorderElements(slide.layoutRef) : [];
        setTextElements(elements.text);
        setImageElements(elements.image);
        setChartElements(elements.chart);
    };

    const getBorderElements = (group: IBaseModel) => {
        const textElements: IElementBaseModel[] = [];
        const imageElements: IElementBaseModel[] = [];
        const chartElements: IElementBaseModel[] = [];
        // eslint-disable-next-line no-restricted-syntax
        for (const child of group.children) {
            if (options?.text && child.type === UIModelType.SHAPE) {
                if (!isEditorEmpty((child as IShapeModel).paragraphList)) {
                    textElements.push(child as IElementBaseModel);
                }
            }
            if (options?.picture && child.type === UIModelType.IMAGE) {
                imageElements.push(child as IElementBaseModel);
            }
            if (options?.chart && child.type === UIModelType.CHART) {
                chartElements.push(child as IElementBaseModel);
            }
            if (child.type === UIModelType.GROUP) {
                textElements.push(...getBorderElements(child).text);
                imageElements.push(...getBorderElements(child).image);
                chartElements.push(...getBorderElements(child).chart);
            }
        }
        return { text: textElements, image: imageElements, chart: chartElements };
    };

    const renderedBorder = (ele: IElementBaseModel, color: string, extraStyle: CSSProperties = {}) => {
        const frameInfoForOuter = SelectedElementWrapperUtil.frameInfoForOuter(ele, true);
        const transformInfo = SelectedElementWrapperUtil.transformForOuter(ele);
        return (
            <div
                style={{
                    ...(frameInfoForOuter as any),
                    position: 'absolute',
                    transform: transformInfo,
                    borderWidth: 5,
                    borderStyle: 'solid',
                    borderColor: color,
                    ...extraStyle,
                }}
            ></div>
        );
    };

    return (
        <>
            {[
                textElements.map(ele => renderedBorder(ele, DEFAULT_TEXT_COLOR, options?.text?.style)),
                imageElements.map(ele => renderedBorder(ele, DEFAULT_IMG_COLOR, options?.picture?.style)),
                chartElements.map(ele => renderedBorder(ele, DEFAULT_CHART_COLOR, options?.chart?.style)),
            ]}
        </>
    );
}
